// ============================================================================
// Admin-editable settings (one versioned document: settings/app). Values that
// used to be hard-coded — the venue name, each weekday's programme, the
// stage-position templates — are now defaults that an admin can change
// without touching code. applySettings() writes them into the same objects
// the rest of the app already reads (WEEKDAYS, STAGE_PRESETS, ...), in place,
// so no other module needed to change how it reads them.
// ============================================================================
import { STR_OVERRIDES } from "./i18n.jsx";
import { WEEKDAYS, STAGE_PRESETS, STAGE_PRESET_CATEGORIES } from "./model.jsx";

const clone = (v) => JSON.parse(JSON.stringify(v));
const DEFAULT_WEEKDAYS = clone(WEEKDAYS);
const DEFAULT_STAGE_PRESETS = clone(STAGE_PRESETS);

const DEFAULT_SETTINGS = {
  venueNameTh: "",
  venueNameEn: "",
  orgName: "",
  weekdays: DEFAULT_WEEKDAYS.map(({ id, name, category, code }) => ({ id, name, category, code })),
  stagePresets: DEFAULT_STAGE_PRESETS,
};

function validStagePresets(v) {
  if (!v || typeof v !== "object" || Array.isArray(v)) return false;
  return Object.values(v).every((list) => Array.isArray(list) && list.every((p) => p && typeof p.pos === "string"));
}

function applySettings(s) {
  const settings = { ...DEFAULT_SETTINGS, ...(s || {}) };
  // weekday programme names/categories/codes (labels stay the calendar's)
  const byId = new Map((Array.isArray(settings.weekdays) ? settings.weekdays : []).map((w) => [w.id, w]));
  WEEKDAYS.forEach((w, i) => {
    const d = DEFAULT_WEEKDAYS[i];
    const o = byId.get(w.id) || {};
    w.name = o.name || d.name;
    w.category = o.category || d.category;
    w.code = o.code || d.code;
  });
  // stage presets: replace contents in place, keep the same object
  const presets = validStagePresets(settings.stagePresets) ? settings.stagePresets : DEFAULT_STAGE_PRESETS;
  Object.keys(STAGE_PRESETS).forEach((k) => delete STAGE_PRESETS[k]);
  Object.assign(STAGE_PRESETS, clone(presets));
  STAGE_PRESET_CATEGORIES.splice(0, STAGE_PRESET_CATEGORIES.length, ...Object.keys(STAGE_PRESETS));
  // branding
  if (settings.venueNameTh || settings.venueNameEn) {
    STR_OVERRIDES.venueName = { th: settings.venueNameTh || settings.venueNameEn, en: settings.venueNameEn || settings.venueNameTh };
  } else {
    delete STR_OVERRIDES.venueName;
  }
  return settings;
}

export { DEFAULT_SETTINGS, applySettings, validStagePresets };
